var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"coming-soon px-3 py-1 font--title-small"},[_vm._v("\n  "+_vm._s(_vm.$t('common.misc.comingSoon'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }